module.exports = __webpack_public_path__ + "84cf578982885782c2993494e1047810.png";